//
// locale_es.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/es.json';
import localeData from "react-intl/locale-data/es.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});



// WEBPACK FOOTER //
// ./tmp/packs/locale_es.js